module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_micro-81d7bcacbfe7de4f0ffe2323d14c3881.png";